import { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { authentication, app } from '@microsoft/teams-js'

export const AuthCallback: FC<object> = () => {
  const [searchParams] = useSearchParams()

  const error = searchParams.get('error')
  const accessToken = searchParams.get('access_token')
  const state = searchParams.get('state')
  const idToken = searchParams.get('id_token')
  const tokenType = searchParams.get('token_type')
  const expiresIn = searchParams.get('expires_in')
  const code = searchParams.get('code')
  const scope = searchParams.get('scope')

  localStorage.setItem('searchParams', JSON.stringify(searchParams))

  useEffect(() => {
    void app.initialize().then(() => {
      if (error !== null) {
        // Authentication/authorization failed
        localStorage.setItem('simple.error', JSON.stringify(error))
        alert(`The callback has an error: ${JSON.stringify(error)}`)
      } else {
        const expectedState = localStorage.getItem('simple.state')

        console.log('this is the expected state', expectedState)

        if (expectedState !== state) {
          alert(`The callback has a different state; ${state ?? ''}; ${expectedState ?? ''}`)
          // State does not match, report error
          localStorage.setItem('simple.error', JSON.stringify({ expectedState, state }))
          authentication.notifyFailure('StateDoesNotMatch')
        } else {
          authentication.notifySuccess(code ?? '')
        }
      }
    })
  }, [accessToken, error, expiresIn, idToken, searchParams, state, tokenType, code, scope])

  return (
    <div>Loading...</div>
  )
}
